import React, { Component } from 'react';
import { Alert, Button, Col, Row } from 'antd';
import { inject, observer } from 'mobx-react';

@inject('store')
@observer
export class LoginView extends Component {
    handleLogin() {
        this.props.store.userStore.login();
    }

    handleRegister() {
        this.props.store.userStore.register();
    }

    componentDidMount() {
        this.props.store.getBaseConfig();
        setInterval(() => {
            this.props.store.getBaseConfig();
        }, 60000);
    }

    render() {
        if (!this.props.store.baseConfig) return null;
        if (this.props.store.baseConfig.disable_login) {
            return (
                <Row
                    type="flex"
                    justify="start"
                    align="middle"
                    style={{ height: '100%' }}
                    gutter={24}
                >
                    <Col xs={{ span: 0 }} md={{ span: 12 }} style={{ height: '100%' }}>
                        <div className="authentication-scene" />
                    </Col>
                    <Col xs={{ span: 24 }} md={{ span: 8, offset: 2 }}>
                        <div className={'authentication-form'}>
                            <Alert
                                style={{ marginBottom: 10 }}
                                message="Apex Scheduled Maintenance"
                                description={this.props.store.baseConfig.maitenance_description}
                                type="warning"
                                showIcon
                            />
                        </div>
                    </Col>
                </Row>
            );
        }

        return (
            <Row type="flex" justify="start" align="middle" style={{ height: '100%' }} gutter={24}>
                <Col xs={{ span: 0 }} md={{ span: 12 }} style={{ height: '100%' }}>
                    <div className="authentication-scene" />
                </Col>
                <Col xs={{ span: 24 }} md={{ span: 8, offset: 2 }}>
                    <div className={'authentication-form'}>
                        <div className={'heading'}>
                            <h1>Login to Continue</h1>
                            <p className={'lead'}>Welcome back, sign in with your Apex account</p>
                        </div>

                        <Button
                            className="btn-cta"
                            block
                            type="primary"
                            onClick={this.handleLogin.bind(this)}
                        >
                            Log in
                        </Button>

                        <Button
                            className="btn-cta"
                            style={{ marginTop: 10 }}
                            block
                            type="primary"
                            onClick={this.handleRegister.bind(this)}
                        >
                            New user? Create an account
                        </Button>
                    </div>
                </Col>
            </Row>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Auth/LoginView.js